export default class Fading {
    constructor(fadeTime, onAnimate, onFinish) {
        this.fadeTime = fadeTime * 1000.0
        this.onAnimate = onAnimate
        this.onFinish = onFinish

        this.animationRequest = null
        this.startTime = null
        this.isFading = false

        this.start = this.start.bind(this)
        this.stop = this.stop.bind(this)
        this.animate = this.animate.bind(this)

        this.t = null

        this.start()
    }

    start() {
        this.t = 0.0
        this.isFading = true
        this.animationRequest = requestAnimationFrame(this.animate)
    }

    stop() {
        this.t = null
        this.isFading = false
        cancelAnimationFrame(this.animationRequest)
    }

    animate(time) {
        if (!this.isFading) {
            return
        }

        if (!this.startTime) {
            this.startTime = time
        }

        this.t = (time - this.startTime) / this.fadeTime
        if (this.onAnimate) {
            this.onAnimate(this.t)
        }

        if (this.t < 1.0) {
            this.animationRequest = requestAnimationFrame(this.animate)
        } else {
            this.t = null
            this.isFading = false
            if (this.onFinish) {
                this.onFinish()
            }
        }
    }
}
